const _ = require('lodash');

export const SEC = 1000;
export const MIN = 60*SEC;
export const HOUR = 60*MIN;
export const DAY = 24*HOUR;
export const WEEK = 7*DAY;
export const MONTH = 4*WEEK;
export const YEAR = 365*DAY;

export const tagFn = cb=>function(parts, ...args){
    let result = '';
    if (!Array.isArray(parts))
        return parts;
    for (let i = 0; i<parts.length; i++) {
        result += parts[i];
        if (i<args?.length)
        {
            let v = args[i];
            result += _.isFunction(v) ? cb(v) : v;
        }
    }
    return result;
};

export const templateToString = tagFn(v=>v());

export const qw = function(parts, ...args) {
    return templateToString(parts, args).trim().split(/\s+/g);
};

export const nl2sp = function(parts, ...args) {
    return templateToString(parts, args).replace(/\s*(\r\n|\r|\n)\s*/g, ' ');
};

export const nl2br = function(parts, ...args) {
    return templateToString(parts, args).replace(/\s*(\r\n|\r|\n)\s*/g, '<br/>');
};

export const getEnv = ()=>{
    let host = window?.location?.host;
    if (host?.includes('localhost'))
        return 'DEV';
    if (host?.includes('simona-cherry-stg'))
        return 'STG';
    if (host?.includes('simonacherry.com'))
        return 'PRD';
    if (process.env.DCHENV=='PRD'||process.env.REACT_APP_ENV=='production')
        return 'PRD';
    if (process.env.DCHENV=='STG'||process.env.REACT_APP_ENV=='staging')
        return 'STG';
    return 'DEV';
};

export const sleep = ms=>new Promise(resolve=>setTimeout(resolve, Math.max(0, ms||0)));

export const wait = ()=>{
    let resolve, reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    return {promise, resolve, reject};
};